var React = require('react');

function SocialYoutube (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M235.5,319.4l83.3-48l-83.3-48V319.4z M235.5,319.4","key":0}),React.createElement("path",{"d":"M267.3,15.5c-141.4,0-256,114.6-256,256s114.6,256,256,256s256-114.6,256-256S408.7,15.5,267.3,15.5\n\t\tL267.3,15.5z M427.3,271.7c0,0,0,51.9-6.6,77c-3.7,13.7-14.5,24.5-28.2,28.2c-25,6.6-125.2,6.6-125.2,6.6s-99.9,0-125.2-6.9\n\t\tc-13.7-3.7-24.5-14.5-28.2-28.2c-6.6-24.8-6.6-76.9-6.6-76.9s0-51.9,6.6-76.9c3.7-13.7,14.8-24.8,28.2-28.5\n\t\tc25-6.6,125.2-6.6,125.2-6.6s100.1,0,125.2,6.9c13.7,3.7,24.5,14.5,28.2,28.2C427.6,219.6,427.3,271.7,427.3,271.7L427.3,271.7z\n\t\t M427.3,271.7","key":1})]));
}

SocialYoutube.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 534.7 543","style":{"enableBackground":"new 0 0 534.7 543"},"xmlSpace":"preserve"};

module.exports = SocialYoutube;

SocialYoutube.default = SocialYoutube;
